import {defineRecipe} from '@chakra-ui/react3'

export default defineRecipe({
    base: {
        margin: 0
    },
    variants: {
        variant: {
            divider: {
                border: '0',
                borderTop: '1px solid',
                borderColor: 'border.subtle',
                inlineSize: '100%'
            },
            text: {
                color: 'text.tertiary',
                textStyle: 'body.xsmall',
                whiteSpace: 'nowrap'
            },
            space: {
                blockSize: '2rem'
            }
        }
    },
    defaultVariants: {
        variant: 'divider'
    }
})
